 <template>
  <div class="page-operative page-add-statement h-100 overflow-hidden d-flex flex-column justify-content-between">
    <!-- Page header -->
    <div class="container d-flex align-items-start justify-content-between mb-3">
      <div class="title-wrapper">
        <PageTitle class="mb-3">Bilancio {{ month }}/{{ year }}</PageTitle>
        <button class="btn small btn-outline-secondary" @click="goBack">
          <i class="fas fa-angle-left mr-1"></i>
          Modifica data
        </button>
      </div>
    </div>

    <!-- Page content -->
    <FormContainer class="flex-grow-1 container overflow-auto custom-scrollbar">
      <BalanceInput v-model="balance" />
    </FormContainer>

    <!-- Save Button -->
    <div class="page-footer text-center py-3">
      <button class="btn btn-primary mx-auto px-4" :disabled="totaleAttivo !== totalePassivo" @click="saveStatement">Salva dati</button>
    </div>
  </div>
</template>

<script>

export default {
  components: {
    PageTitle: () => import('../../../components/Layout/LayoutOperative/PageTitle'),
    FormContainer: () => import('../../../../libs/Form/components/FormContainer'),
    BalanceInput: () => import('../../../components/Operative/Form/Widgets/BalanceInput'),
  },
  props: {
    year: null,
    month: null,
    balance: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    totaleImmobilizzazioni () {
      let totale = (this.balance?.immobilizzazioniMaterialiEImmateriali || 0);
      totale += (this.balance?.immobilizzazioniFinanziarie || 0);

      return Math.floor(totale);
    },
    totaleCrediti () {
      let totale = (this.balance?.creditiVsClienti || 0);
      totale += (this.balance?.creditiTributariPerImposte || 0);
      totale += (this.balance?.creditoDImposta || 0);
      totale += (this.balance?.creditoIva || 0);
      totale += (this.balance?.altriCrediti || 0);

      return Math.floor(totale);
    },
    attivoCircolante () {
      let totale = this.totaleCrediti;
      totale += (this.balance?.scorte || 0);
      totale += (this.balance?.disponibilita || 0);

      return Math.floor(totale);
    },
    totaleAttivo () {
      let totale = this.totaleImmobilizzazioni;
      totale += this.attivoCircolante;
      totale += (this.balance?.rateiAttivi || 0);

      return Math.floor(totale);
    },

    patrimonioNetto () {
      let totale = (this.balance?.capitaleSociale || 0);
      totale += (this.balance?.riserve || 0);
      totale += (this.balance?.utiliPerditePregresse || 0);
      totale += (this.balance?.risultatoDEsercizio || 0);
      totale += (this.balance?.prestitoSoci || 0);

      return Math.floor(totale);
    },
    passivitaConsolidate () {
      let totale = (this.balance?.fondoTfr || 0);
      totale += (this.balance?.altriFondi || 0);
      totale += (this.balance?.finanziamentiAMedioLungoTermine || 0);

      return Math.floor(totale);
    },
    passivitaCorrenti () {
      let totale = (this.balance?.banche || 0);
      totale += (this.balance?.quoteABreveTermineDiFinanziamenti || 0);
      totale += (this.balance?.fornitori || 0);
      totale += (this.balance?.debitoIva || 0);
      totale += (this.balance?.debitiTributariPerImposte || 0);
      totale += (this.balance?.debitiTributariPerRitenute || 0);
      totale += (this.balance?.debitiVersoEntiPrevidenziali || 0);
      totale += (this.balance?.altriDebiti || 0);

      return Math.floor(totale);
    },
    totalePassivo () {
      let totale = this.patrimonioNetto;
      totale += this.passivitaConsolidate;
      totale += this.passivitaCorrenti;
      totale += (this.balance?.rateiPassivi || 0);

      return Math.floor(totale);
    },
  },
  methods: {
    goBack () {
      this.$emit('goBack');
    },
    saveStatement () {
      this.$emit('save', {
        year: this.year,
        month: this.month,
        balance: this.balance,
      });
    },
  },
};

</script>

<style lang="scss"></style>
